import { IAlarp } from '../types'
import { BOWTIE_BASE_URL, BOWTIE_REST_ENDPOINTS } from '../utils/constants'

export const listAlarp = async (): Promise<IAlarp[]> => {
    const qs = new URLSearchParams({}).toString()

    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.alarp}/?${qs}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const updateAlarp = async (alarp: IAlarp): Promise<IAlarp> => {
    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.alarp}/${alarp.id}`, {
        method: 'PATCH',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(alarp)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}
